export default "__VITE_ASSET__BouUNfyC__"